import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import fsltlLogo from "../../images/templates/fsltl.png";

export const fsltlTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "fsltl",
  title: "FSLTL",
  platforms: ["msfs"],
  image: fsltlLogo,
  content: [
    {
      title: "Before Simulator Start",
      roles: ["beforeSimStart"],
      content: [{ item: "FSLTL Models", setting: "Updated" }],
    },
    {
      title: "Before Start",
      roles: ["cockpitPreparation", "beforeFlightStart"],
      content: [{ item: "FSLTL Injector", setting: "Started" }],
    },
  ],
};
